function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import moment from 'moment';
import includes from 'lodash/includes';
import omit from 'lodash/omit';
import forEach from 'lodash/forEach';
import cn from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import filter from 'lodash/filter';
import ManuallyEnteredReading from 'svg/mobileReports/manuallyEnteredReading.svg';
import { formatDate } from 'helpers/datetime';
import App from 'modules/App';
import intlShape from 'shapes/intlShape';
import { calculateData } from 'helpers/kpi';
import * as constants from 'modules/PatientResults/constants';
import * as selectors from 'modules/PatientResults/selectors';
import StatsCalculations from '../../libs/StatsCalculations';
import messages from '../../messages';
import Header from './Header';
import Table from './Table';
import { Footer } from './Footer';
import GlucoseLevelDistributionChart from './GlucoseLevelDistributionBarChart';
import BloodGlucoseConcentrationChart from './BloodGlucoseConcentrationChart';
import styles from './BloodGlucoseConcentrationReport.pcss';
var _React_Component;
class BloodGlucoseConcentrationReport extends (_React_Component = React.Component) {
    get chartData() {
        const { customRanges } = this.props;
        const statsCalculations = new StatsCalculations(this.data.readings14, this.props.standards, customRanges, 'value', 'timestamp');
        const averageData = statsCalculations.group('HOURS_RANGE', 'MEAN').map((item)=>_object_spread_props(_object_spread({}, item), {
                isAverage: true
            }));
        return {
            readings: statsCalculations.group('HOURS_RANGE', 'NONE'),
            averageData
        };
    }
    get chartDataPreMeal() {
        const { customRanges, standards } = this.props;
        const preMealStandards = omit(standards, 'postMeal');
        const statsCalculations = new StatsCalculations(this.data.preMealReadings, preMealStandards, customRanges, 'value', 'timestamp');
        const averageData = statsCalculations.group('HOURS_RANGE', 'MEAN').map((item)=>_object_spread_props(_object_spread({}, item), {
                isAverage: true
            }));
        return {
            readings: statsCalculations.group('HOURS_RANGE', 'NONE'),
            averageData,
            standards: preMealStandards
        };
    }
    get chartDataPostMeal() {
        const { customRanges, standards } = this.props;
        const preMealStandards = omit(standards, 'preMeal');
        const statsCalculations = new StatsCalculations(this.data.postMealReadings, preMealStandards, customRanges, 'value', 'timestamp');
        const averageData = statsCalculations.group('HOURS_RANGE', 'MEAN').map((item)=>_object_spread_props(_object_spread({}, item), {
                isAverage: true
            }));
        return {
            readings: statsCalculations.group('HOURS_RANGE', 'NONE'),
            averageData,
            standards: preMealStandards
        };
    }
    get maxPlainValue() {
        const { calculationFormula } = this.props;
        if (includes([
            'HYPERGLYCEMIA',
            'HYPOGLYCEMIA'
        ], calculationFormula)) {
            return 100;
        }
        return 20;
    }
    get unitSymbol() {
        const { calculationFormula } = this.props;
        if (includes([
            'HYPERGLYCEMIA',
            'HYPOGLYCEMIA'
        ], calculationFormula)) {
            return '%';
        }
        return null;
    }
    get ticks() {
        const startDate = moment().utc();
        const endDate = moment().utc();
        const ticksPoints = [];
        startDate.startOf('day');
        endDate.endOf('day');
        ticksPoints.push(+startDate.format('X'));
        const breakpoints = [
            ...this.props.customRanges
        ];
        breakpoints.shift();
        forEach(breakpoints, (hourBreakpoint)=>{
            ticksPoints.push(+startDate.hour(hourBreakpoint[0]).minutes(hourBreakpoint[1]).format('X'));
        });
        ticksPoints.push(+endDate.format('X') + 1);
        return ticksPoints;
    }
    get gridTheme() {
        return {
            grid: {
                stroke: '#E0E8F4',
                strokeWidth: 1
            }
        };
    }
    renderUnit() {
        return /*#__PURE__*/ _jsx("p", {
            className: styles.printableBloodGlucoseConcentrationReport__concentrationUnit,
            children: this.props.conversion.unitSymbol
        });
    }
    renderContent() {
        var _this_chartData, _this;
        const { conversion, standards, endDate } = this.props;
        const { readings7, readings14, readings30, readings60, readings90 } = this.data;
        const start = moment.utc().startOf('day').unix();
        const end = moment.utc().endOf('day').unix();
        const endDate14 = moment.utc(endDate).endOf('day');
        const startDate14 = endDate14.clone().add(-13, 'days').startOf('day');
        const endDate30 = moment.utc(endDate).endOf('day');
        const startDate30 = endDate30.clone().add(-29, 'days').startOf('day');
        const endDate60 = startDate30.clone().add(-1, 'days').endOf('day');
        const startDate60 = endDate60.clone().add(-29, 'days').startOf('day');
        const endDate90 = startDate60.clone().add(-1, 'days').endOf('day');
        const startDate90 = endDate90.clone().add(-29, 'days').startOf('day');
        const unmarkedReadings = filter((_this_chartData = this.chartData) === null || _this_chartData === void 0 ? void 0 : _this_chartData.readings, (r)=>r.flags === 'None');
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.printableBloodGlucoseConcentrationReport,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.printableBloodGlucoseConcentrationReport__header,
                    children: /*#__PURE__*/ _jsx(Header, {
                        phiSet: this.props.phiSet,
                        accountPatientProfile: this.props.accountPatientProfile,
                        standards: this.props.standards,
                        conversion: conversion
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.printableBloodGlucoseConcentrationReport__row,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.printableBloodGlucoseConcentrationReport__column,
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: styles.printableBloodGlucoseConcentrationReport__chartTitle,
                                    children: [
                                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.glucoseReport.headerBloodGlucoseHeader)),
                                        /*#__PURE__*/ _jsx("br", {}),
                                        /*#__PURE__*/ _jsx("span", {
                                            children: `${formatDate(startDate14, 'MMMM D')} - ${formatDate(endDate14, 'MMMM D, YYYY')}`
                                        }),
                                        this.renderUnit()
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(BloodGlucoseConcentrationChart, {
                                    disableTooltip: true,
                                    conversion: conversion,
                                    standards: standards,
                                    readings: this.chartData.readings,
                                    averageData: this.chartData.averageData,
                                    start: start,
                                    end: end,
                                    timestampKey: "timestamp",
                                    valueKey: "value",
                                    direction: this.props.direction,
                                    maxPlainValue: this.maxPlainValue,
                                    unitSymbol: this.unitSymbol,
                                    isLineEnabled: false,
                                    isGridXEnabled: undefined,
                                    isPlainValuesMode: false,
                                    isReadOnly: true,
                                    printMode: true,
                                    isCustomRanges: true,
                                    ticks: this.ticks,
                                    customRangesLabels: [
                                        undefined,
                                        undefined,
                                        undefined,
                                        undefined
                                    ],
                                    formatLabel: ()=>'',
                                    enableGridY: false,
                                    gridTheme: this.gridTheme,
                                    criticalHigh: constants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES[conversion.unit].veryHigh,
                                    criticalLow: constants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES[conversion.unit].low
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: cn(styles.printableBloodGlucoseConcentrationReport__chartFooter, styles['printableBloodGlucoseConcentrationReport__chartFooter--allReadings']),
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.glucoseReport.bloodGlucoseBottom))
                                        }),
                                        /*#__PURE__*/ _jsx("b", {
                                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.glucoseReport.bloodGlucoseBottomUnmarkedReadings), {
                                                values: {
                                                    count: ((_this = unmarkedReadings || []) === null || _this === void 0 ? void 0 : _this.length) || 0
                                                }
                                            }))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.printableBloodGlucoseConcentrationReport__column,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.printableBloodGlucoseConcentrationReport__chartTitle,
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.glucoseReport.headerGlucoseLevelHeader))
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: styles.printableBloodGlucoseConcentrationReport__bars,
                                    children: [
                                        /*#__PURE__*/ _jsx(GlucoseLevelDistributionChart, {
                                            disableTooltip: true,
                                            conversion: conversion,
                                            standards: standards,
                                            readings: readings90,
                                            start: startDate90,
                                            end: endDate90,
                                            valueKey: "value"
                                        }),
                                        /*#__PURE__*/ _jsx(GlucoseLevelDistributionChart, {
                                            disableTooltip: true,
                                            conversion: conversion,
                                            standards: standards,
                                            readings: readings60,
                                            start: startDate60,
                                            end: endDate60,
                                            valueKey: "value"
                                        }),
                                        /*#__PURE__*/ _jsx(GlucoseLevelDistributionChart, {
                                            disableTooltip: true,
                                            conversion: conversion,
                                            standards: standards,
                                            readings: readings30,
                                            start: startDate30,
                                            end: endDate30,
                                            valueKey: "value"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.printableBloodGlucoseConcentrationReport__row,
                    children: /*#__PURE__*/ _jsx(Table, {
                        readings7: readings7,
                        readings14: readings14,
                        readings30: readings30,
                        conversion: conversion,
                        standards: standards
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.printableBloodGlucoseConcentrationReport__row,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.printableBloodGlucoseConcentrationReport__column,
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: styles.printableBloodGlucoseConcentrationReport__chartTitle,
                                    children: [
                                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.glucoseReport.headerBloodGlucoseHeaderPreMeal)),
                                        /*#__PURE__*/ _jsx("br", {}),
                                        /*#__PURE__*/ _jsx("span", {
                                            children: `${formatDate(startDate14, 'MMMM D')} - ${formatDate(endDate14, 'MMMM D, YYYY')}`
                                        }),
                                        this.renderUnit()
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(BloodGlucoseConcentrationChart, {
                                    disableTooltip: true,
                                    conversion: conversion,
                                    standards: this.chartDataPreMeal.standards,
                                    readings: this.chartDataPreMeal.readings,
                                    averageData: this.chartDataPreMeal.averageData,
                                    start: start,
                                    end: end,
                                    timestampKey: "timestamp",
                                    valueKey: "value",
                                    direction: this.props.direction,
                                    maxPlainValue: this.maxPlainValue,
                                    unitSymbol: this.unitSymbol,
                                    isLineEnabled: false,
                                    isGridXEnabled: undefined,
                                    isPlainValuesMode: false,
                                    isReadOnly: true,
                                    printMode: true,
                                    isCustomRanges: true,
                                    ticks: this.ticks,
                                    customRangesLabels: [
                                        undefined,
                                        undefined,
                                        undefined,
                                        undefined
                                    ],
                                    formatLabel: ()=>'',
                                    enableGridY: false,
                                    criticalHigh: constants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES[conversion.unit].veryHigh,
                                    criticalLow: constants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES[conversion.unit].low
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: cn(styles.printableBloodGlucoseConcentrationReport__chartFooter, styles.greenFont),
                                    children: `${this.props.intl.formatMessage(messages.glucoseReport.bloodGlucoseBottomPreMeal)} = ${conversion.toDisplay(standards.preMeal.lowThreshold)} - ${conversion.toDisplay(standards.preMeal.highThreshold)} ${conversion.unitSymbol}`
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.printableBloodGlucoseConcentrationReport__column,
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: styles.printableBloodGlucoseConcentrationReport__chartTitle,
                                    children: [
                                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.glucoseReport.headerBloodGlucoseHeaderPostMeal)),
                                        /*#__PURE__*/ _jsx("br", {}),
                                        /*#__PURE__*/ _jsx("span", {
                                            children: `${formatDate(startDate14, 'MMMM D')} - ${formatDate(endDate14, 'MMMM D, YYYY')}`
                                        }),
                                        this.renderUnit()
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(BloodGlucoseConcentrationChart, {
                                    disableTooltip: true,
                                    conversion: conversion,
                                    standards: this.chartDataPostMeal.standards,
                                    readings: this.chartDataPostMeal.readings,
                                    averageData: this.chartDataPostMeal.averageData,
                                    start: start,
                                    end: end,
                                    timestampKey: "timestamp",
                                    valueKey: "value",
                                    direction: this.props.direction,
                                    maxPlainValue: this.maxPlainValue,
                                    unitSymbol: this.unitSymbol,
                                    isLineEnabled: false,
                                    isGridXEnabled: undefined,
                                    isPlainValuesMode: false,
                                    isReadOnly: true,
                                    printMode: true,
                                    isCustomRanges: true,
                                    ticks: this.ticks,
                                    customRangesLabels: [
                                        undefined,
                                        undefined,
                                        undefined,
                                        undefined
                                    ],
                                    formatLabel: ()=>'',
                                    enableGridY: false,
                                    criticalHigh: constants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES[conversion.unit].veryHigh,
                                    criticalLow: constants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES[conversion.unit].low
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: cn(styles.printableBloodGlucoseConcentrationReport__chartFooter, styles.greenFont),
                                    children: `${this.props.intl.formatMessage(messages.glucoseReport.bloodGlucoseBottomPostMeal)} = ${conversion.toDisplay(standards.postMeal.lowThreshold)} - ${conversion.toDisplay(standards.postMeal.highThreshold)} ${conversion.unitSymbol}`
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.printableBloodGlucoseConcentrationReport__manuallyEnteredReading,
                    children: [
                        /*#__PURE__*/ _jsx(ManuallyEnteredReading, {}),
                        " ",
                        /*#__PURE__*/ _jsx("p", {
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.glucoseReport.manuallyEnteredReading))
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.printableBloodGlucoseConcentrationReport__footer,
                    children: /*#__PURE__*/ _jsx(Footer, {
                        generatedDate: new Date()
                    })
                })
            ]
        });
    }
    render() {
        if (!this.props.phiSet) return null;
        return this.renderContent();
    }
    constructor(props){
        super(props);
        this.data = _object_spread_props(_object_spread({}, calculateData(props.readings14)), {
            readings7: props.readings7,
            readings14: props.readings14,
            readings30: props.readings30,
            readings60: props.readings30to60,
            readings90: props.readings60to90
        });
    }
}
_define_property(BloodGlucoseConcentrationReport, "propTypes", {
    // Explicit props
    direction: PropTypes.string,
    endDate: PropTypes.object,
    conversion: PropTypes.object.isRequired,
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }),
    phiSet: PropTypes.object,
    customRanges: PropTypes.array,
    accountPatientProfile: PropTypes.object,
    // Implicit props
    intl: intlShape.isRequired,
    readings7: PropTypes.array,
    readings14: PropTypes.array,
    readings30: PropTypes.array,
    readings30to60: PropTypes.array,
    readings60to90: PropTypes.array,
    featureToggles: PropTypes.array,
    // Implicit actions
    calculationFormula: PropTypes.oneOf(constants.CALCULATION_FORMULAS)
});
const mapStateToProps = (state)=>({
        readings7: selectors.readingsRangeDate(state)(0, 7),
        readings14: selectors.readingsRangeDate(state)(0, 14),
        readings30: selectors.readingsRangeDate(state)(0, 30),
        readings30to60: selectors.readingsRangeDate(state)(30, 30),
        readings60to90: selectors.readingsRangeDate(state)(60, 30),
        featureToggles: App.selectors.featureToggles(state),
        direction: App.selectors.direction(state)
    });
const ConnectedBloodGlucoseConcentrationReport = connect(mapStateToProps)(BloodGlucoseConcentrationReport);
export default withStyles(styles)(injectIntl(ConnectedBloodGlucoseConcentrationReport));
